import { Id, LaravelResponse, PagedSingleSelectField, UserOptionResource, laravelSelectFetchConfig } from "@dgs/core";
import { FC, useMemo } from "react";
import { createEventUserService } from "../../api/userService";
import { UserSelectOption } from "./UserSelectOption";

const emptyResponse: LaravelResponse<UserOptionResource[]> = {
	data: [],
	meta: {
		current_page: 0,
		from: 0,
		last_page: 0,
		per_page: 0,
		to: 0,
		total: 0,
	},
};

interface Props {
	eventId: Id;
	name: string;
	label: string;
	required?: boolean;
	disabled?: boolean;
	clearable?: boolean;
}

export const EventUserSingleSelect: FC<Props> = ({ eventId, ...props }) => {
	const eventUserService = useMemo(() => createEventUserService(eventId), [eventId]);

	return (
		<PagedSingleSelectField
			{...props}
			fetchConfig={laravelSelectFetchConfig(eventUserService.getAvailableUsersKey, async (search, page) =>
				eventId === "" ? emptyResponse : eventUserService.getAvailableUsers(search, page).then((r) => r.data),
			)}
			renderOption={(o, isSelected) => <UserSelectOption isSelected={isSelected} user={o} />}
			getLabel={(o) => `${o.name} (${o.email})`}
		/>
	);
};
